<template>
    <AppLayout>
        <!-- <div class="container px-3 py-4 mx-auto md:px-6 lg:px-8"> -->
        <div class="container py-4">
            <!-- breadcrumb -->
            <nav
                class="mb-6 text-sm font-semibold"
                aria-label="Breadcrumb"
            >
                <ol class="inline-flex p-0 list-none">
                    <li class="flex items-center text-gray-600">
                        <GoBack :text="$t('LBL_BACK')" />
                        <svg
                            fill="#34D399"
                            class="w-3 h-3 mx-3 "
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                        >
                            <path
                                d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                            />
                        </svg>
                    </li>
                    <li class="flex items-center">
                        <a
                            href="#"
                            class="text-gray-600"
                        >
                            {{ $tc('LBL_ORDER', 1) }}
                        </a>
                    </li>
                </ol>
            </nav>
            <!-- <div class="flex">
                <GoBack />
                <h1 class="mb-4 font-bold md:text-2xl">
                    {{ $tc('LBL_ORDER', 1) }}
                </h1>
            </div> -->

            <div class="w-full my-3 text-xs bg-white rounded shadow-sm md:text-sm">
                <div class="flex flex-col md:items-center md:flex-row md:justify-between">
                    <div class="flex flex-col p-2">
                        <p class="font-semibold">
                            Order <span class="text-green-600">#{{ bill.bill_number }} </span>
                        </p>

                        <div
                            v-if="($page.props.roles[0] === 'retailer' && bill.wholesaler) ||
                                ($page.props.roles[0] !== 'retailer' && bill.user)"
                            class="flex"
                        >
                            <span class="mr-1 text-gray-400">
                                {{ $page.props.roles[0] === 'retailer' ? 'From' : 'By' }}</span>
                            <p class="font-semibold">
                                {{ $page.props.roles[0] === 'retailer' ? bill.wholesaler.name : bill.user.name }}
                            </p>
                        </div>

                        <p class="text-xs text-gray-400">
                            Placed on {{ bill.created_at | readableDate }}
                        </p>
                    </div>

                    <div class="flex items-center p-2">
                        <div class="flex items-center gap-4">
                            <div
                                v-if="isBillPaid(bill)"
                                class="flex items-center gap-2"
                            >
                                <div class="px-2 py-1 text-white bg-green-400 rounded">
                                    Paid
                                </div>
                                <button
                                    class="p-1 rounded-full cursor-pointer hover:bg-gray-200"
                                    title="Print Invoice"
                                    @click="printInvoice(bill)"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="icon icon-tabler icon-tabler-printer"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        stroke-width="2"
                                        stroke="currentColor"
                                        fill="none"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    >
                                        <rect
                                            x="0"
                                            y="0"
                                            width="24"
                                            height="24"
                                            stroke="none"
                                        />
                                        <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" />
                                        <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" />
                                        <rect
                                            x="7"
                                            y="13"
                                            width="10"
                                            height="8"
                                            rx="2"
                                        />
                                    </svg>
                                </button>
                            </div>

                            <div
                                v-if="isBillPending(bill)"
                                class="flex items-center gap-2"
                            >
                                <div class="px-4 py-2 bg-blue-300 rounded opacity-50">
                                    Pending
                                </div>
                                <button
                                    v-if="isProductsPacked(bill)"
                                    class="p-1 rounded-full cursor-pointer hover:bg-gray-200"
                                    title="Print Invoice"
                                    @click="printInvoice(bill)"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="icon icon-tabler icon-tabler-printer"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        stroke-width="2"
                                        stroke="currentColor"
                                        fill="none"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    >
                                        <rect
                                            x="0"
                                            y="0"
                                            width="24"
                                            height="24"
                                            stroke="none"
                                        />
                                        <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" />
                                        <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" />
                                        <rect
                                            x="7"
                                            y="13"
                                            width="10"
                                            height="8"
                                            rx="2"
                                        />
                                    </svg>
                                </button>
                            </div>

                            <div
                                v-if="isBillPartial(bill)"
                                class="px-4 py-2 bg-yellow-300 rounded opacity-50"
                            >
                                Partial
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    v-for="order in bill.transactions"
                    :key="'order-' + order.id"
                    class="flex flex-col gap-2 p-5 md:flex-row md:gap-4"
                >
                    <div class="flex flex-col mb-3 md:flex-row md:gap-3 md:w-2/5">
                        <div class="flex-shrink-0 w-full md:w-1/3">
                            <img
                                :src="order.product.images.length > 0 ? order.product.images[0].image_path : common.defaultImg"
                                alt="Product Image"
                                class="w-full h-32 cursor-pointer md:h-28"
                                @click="goto('products.show', { dummy: `${convertToKebabCase(order.product.brand.name)}-${convertToKebabCase(order.product.name)}`, product: order.product.slug })"
                            >
                        </div>
                        <div class="mt-1 md:flex-grow">
                            <div
                                class="mb-4 font-semibold cursor-pointer line-clamp-3"
                                @click="goto('products.show', { dummy: `${convertToKebabCase(order.product.brand.name)}-${convertToKebabCase(order.product.name)}`, product: order.product.slug })"
                            >
                                {{ order.product.name }}
                            </div>
                            <div class="flex text-gray-500">
                                <img
                                    v-if="order.product.brand.images.length"
                                    :src="order.product.brand.images[0].image_path"
                                    class="h-5 mr-2"
                                >
                                {{ order.product.brand.name }}
                            </div>
                        </div>
                    </div>
                    <div class="md:w-1/5">
                        <div>Qty: {{ order.qty }}</div>
                        <div>Price/Piece: {{ config(common.currency, order.product.owner) }} {{ parseFloat(order.product.price).toFixed(2) }}</div>
                    </div>
                    <div class="flex-col justify-center p-1 rounded md:w-2/5 md:flex bg-gray-50">
                        <div class="flex justify-between">
                            <p>Subtotal ({{ order.qty }} item)</p>
                            <p>{{ config(common.currency, order.product.owner) }} {{ (order.qty * order.product.price).toFixed(2) }}</p>
                        </div>
                        <div
                            v-if="order.vat != 0"
                            class="flex justify-between"
                        >
                            <p>Vat</p>
                            <p>+ {{ config(common.currency, order.product.owner) }} {{ order.vat }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>Discount</p>
                            <p class="text-red-500">
                                - {{ config(common.currency, order.product.owner) }} {{ order.discount }}
                            </p>
                        </div>
                        <hr>
                        <div class="flex justify-between mt-1 text-lg">
                            <p>Total</p>
                            <p class="font-semibold text-green-500">
                                {{ config(common.currency, order.product.owner) }} {{ order.grand_total }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="flex items-center justify-end">
                    <div class="flex justify-between mt-1 text-lg md:w-2/5">
                        <p>Grand total</p>
                        <p class="font-semibold text-green-500">
                            {{ config(common.currency) }} {{ parseFloat(bill.total_amount).toFixed(2) }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
import AppLayout from '../../Layouts/AppLayout.vue';
import GoBack from '../../Components/GoBack.vue';
import common from '../../common';

export default {
    name: 'TransactionsOfBill',

    components: {
        AppLayout,
        GoBack,
    },

    props: {
        bill: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            common,
        };
    },

    computed: {
        defaultImage() {
            return `${process.env.MIX_SENTRY_DSN_PUBLIC}/storage/default/default.png`;
        },
    },

    methods: {
        isBillPaid(bill) {
            if (bill.payment_status === 'Paid') {
                return true;
            }
            return false;
        },

        isBillPending(bill) {
            if (bill.payment_status === 'Pending') {
                return true;
            }
            return false;
        },

        isProductsPacked(bill) {
            if (bill.delivery_status === 'Packed') {
                return true;
            }
            return false;
        },

        isBillPartial(bill) {
            if (bill.payment_status === 'Partial') {
                return true;
            }
            return false;
        },
    },
};
</script>
